export default {
  SET_SMS_DATA(state, smsData) {
    state.sms = smsData;
  },
};
